import React from 'react'
import "./Title_Component.css";

const Title_Component = (props) => {
    return (
        <section className='Title_Component'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-5 col-md-5 col-sm-10 col-10'>

                        <div className='left_side'>
                            <div className='main_img_holder'>
                                <img src={props?.image1} className='big_img' />

                                <div className='second_img_holder'>
                                    <img src={props?.image2} className='small_img' />
                                </div>
                            </div>


                        </div>

                    </div>

                    <div className='col-lg-7 col-md-7 col-sm-12 col-12'>
                        <div className='right_side'>
                            <div className='heading_div'>
                                <p className='heading'>{props?.title}</p>
                            </div>

                            <div className='description_div'>
                                <p className='description'>
                                    {props?.description}
                                </p>
                            </div>

                            <hr class="seperator"></hr>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Title_Component
